<template>
    <crud-facecade
        :key="1"
        ref="doc_list"
        :url="url"
        :tableHeight="tableHeight"
        :columns="columnList"
        :buttons="[]"
        :addButton="{ enabled: false, emit: 'addDocument', permission: 'default' }"
        :deleteButton="{ enabled: false, permission: 'default' }"
        :updateButton="{ enabled: false, permission: 'default' }"
    >
    </crud-facecade>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
export default {
    name: `DocumentConfgPatient`,
    data() {
        return {
            title: `患者文书`,
            list: [],
            list2: [],
            docGroupNames: [],
            activeName: `first`
        }
    },
    created() {
        this.loadDocGroupConfig()
    },
    computed: {
        ...mapGetters([`ward_auth`, `sys_enums`, `screenHeight`]),
        tableHeight() {
            return this.screenHeight && (this.screenHeight - 190) || 0
        },
        url() {
            return {
                baseURL: ``,
                get: () => {
                    return new Promise((resolve, reject) => {
                        let req = this.myaxios.get(`/api/AcisSystem/DocumentConfig/Get`)
                        let req2 = this.loadDocList()

                        this.myaxios
                            .all(req, req2)
                            .then(([config, doclist]) => {
                                let data = _.map(doclist, d => {
                                    let cdoc = _.find(config, { document_id: d.DocNo })
                                    console.log(cdoc)
                                    return {
                                        id: cdoc && cdoc.id,
                                        no: `${d.SysId}_${d.DocNo}`,
                                        docno: d.DocNo,
                                        docname: d.DocName,
                                        group_name: cdoc && cdoc.group_name,
                                        display_order: cdoc && cdoc.display_order,
                                        default_printer_name: cdoc && cdoc.default_printer_name,
                                        default_printer_name_by_ward: cdoc && cdoc.default_printer_name_by_ward,
                                        is_singleton: cdoc && cdoc.is_singleton,
                                        is_sign_multiple_times: cdoc && cdoc.is_sign_multiple_times,
                                        is_show_medical: cdoc && cdoc.is_show_medical,
                                        is_deleted: cdoc && cdoc.is_deleted,
                                        doc_type: cdoc && cdoc.doc_type && cdoc.doc_type.split(`,`),
                                        enum_worker_role: (cdoc && cdoc.enum_worker_role) || 0,
                                        regions:
                                            (cdoc &&
                                                cdoc.regions &&
                                                cdoc.regions.map(d => {
                                                    return d.dic_operating_ward_id ? `ow_${d.dic_operating_ward_id}` : `rw_${d.dic_recovery_ward_id}`
                                                })) ||
                                            []
                                    }
                                })
                                this.list = _.orderBy(data, `display_order`)

                                resolve(data)
                            })
                            .catch(e => reject(e))
                    })
                },
                putMany: rows => {
                    let reqs = rows.map(d => {
                        let oldrow = _.find(this.list, { no: d.no })
                        let newrow = Object.assign({}, oldrow, d)
                        console.log(newrow)
                        return this.myaxios.put(`/api/AcisSystem/DocumentConfig/Put`, {
                            id: newrow.id,
                            document_id: newrow.docno,
                            is_singleton: newrow.is_singleton,
                            is_show_medical: newrow.is_show_medical,
                            is_sign_multiple_times: newrow.is_sign_multiple_times,
                            is_deleted: newrow.is_deleted,
                            default_printer_name: newrow.default_printer_name,
                            default_printer_name_by_ward: newrow.default_printer_name_by_ward,
                            doc_type: newrow.doc_type && newrow.doc_type.toString(),
                            name: newrow.docname,
                            group_name: newrow.group_name,
                            display_order: newrow.display_order,
                            enum_worker_role: newrow.enum_worker_role,
                            regions:
                                newrow.regions &&
                                newrow.regions.map(d => {
                                    return {
                                        sys_document_config_id: d.id,
                                        dic_operating_ward_id: _.startsWith(d, `ow_`) ? d.replace(`ow_`, ``) : ``,
                                        dic_recovery_ward_id: _.startsWith(d, `rw_`) ? d.replace(`rw_`, ``) : ``
                                    }
                                })
                        })
                    })

                    return new Promise((resolve, reject) => {
                        let req = this.myaxios.all(...reqs)
                        req.then(res => {
                            this.$refs.doc_list.ReloadListData()
                            this.$message.success(`保存成功`)
                            resolve()
                        }).catch(e => {
                            reject(e)
                        })
                    })
                }
            }
        },
        dic_roles() {
            return [
                {
                    value: 0,
                    label: `通用`,
                    jianpin: `TY`,
                    code: ``
                }
            ].concat(this.sys_enums.Enum_WorkerRole)
        },
        columnList() {
            return [
                {
                    type: `string`,
                    prop: `no`,
                    label: `no`,
                    isKey: true
                },
                {
                    type: `number`,
                    prop: `display_order`,
                    label: `排序`,
                    width: `120`,
                    isListable: true,
                    isExpand: false,
                    readonly: false,
                    sortable: true,
                    isDisplayOrder: true
                },
                {
                    type: `string`,
                    prop: `docno`,
                    label: `文书编号`,
                    width: `120`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `docname`,
                    label: `名称`,
                    width: `240`,
                    isListable: true
                },
                {
                    type: `select`,
                    prop: `group_name`,
                    label: `所属分组`,
                    width: `120`,
                    isListable: this.docGroupNames.length > 0,
                    isEditable: this.docGroupNames.length > 0,
                    isCreatable: this.docGroupNames.length > 0,
                    readonly: false,
                    options: this.docGroupNames
                },
                {
                    //   type: "string",
                    //   prop: "Operator",
                    //   label: "操作人",
                    //   isListable: true
                    // },{
                    //   type: "multiselect",
                    //   prop: "doc_type",
                    //   label: "文书类型",
                    //   isListable: true,
                    //   isExpand: false,
                    //   isEditable: true,
                    //   isCreatable: true,
                    //   options: this.sys_document,
                    //   readonly:false,
                    //   config:{
                    //     collapseTags:false
                    //   }
                    // },{
                    type: `bool`,
                    prop: `is_singleton`,
                    label: `是否单例`,
                    width: `80`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    options: `enum_bool`,
                    default: false,
                    readonly: (that, { row }) => {
                        return row.isReadOnly || (row.doc_type != null && row.doc_type !== ``)
                    }
                },
                {
                    type: `bool`,
                    prop: `is_show_medical`,
                    label: `是否病案显示`,
                    width: `100`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    options: `enum_bool`,
                    default: false,
                    readonly: (that, { row }) => {
                        return false
                    }
                },
                {
                    type: `bool`,
                    prop: `is_sign_multiple_times`,
                    label: `是否多次签名`,
                    width: `100`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    options: `enum_bool`,
                    default: false,
                    readonly: (that, { row }) => {
                        return false
                    }
                },
                {
                    type: `bool`,
                    prop: `is_deleted`,
                    label: `是否禁用`,
                    width: `80`,
                    isListable: true,
                    isExpand: false,
                    options: `enum_bool`,
                    default: false,
                    readonly: false
                },
                {
                    type: `select`,
                    prop: `enum_worker_role`,
                    label: `所属角色`,
                    width: `120`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    options: this.dic_roles,
                    readonly: false
                },
                {
                    type: `multiselect`,
                    prop: `regions`,
                    label: `所属区`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    options: this.ward_auth,
                    readonly: false,
                    config: {
                        popperAppendToBody: true,
                        collapseTags: false
                    }
                }, {
                    type: `string`,
                    prop: `default_printer_name`,
                    label: `默认打印机名称`,
                    isListable: true,
                    readonly: false
                }, {
                    type: `string`,
                    prop: `default_printer_name_by_ward`,
                    label: `区域配置默认打印机名称`,
                    isListable: true,
                    readonly: false
                }
            ]
        }
    },
    methods: {
        loadDocGroupConfig() {
            let that = this
            that.docGroupNames = []
            let req = this.myaxios.get(`api/AcisSystem/Config/GetByKey?key=DocGroupNamesConfig`) // 获取参数信息
            req.then(data => {
                if (data && data.value && data.value != ``) {
                    let ret = data.value.split(`|`)
                    _.forEach(ret, d => {
                        that.docGroupNames.push({
                            value: d,
                            label: d
                        })
                    })
                    console.log(`that.docGroupNames`)
                    console.log(that.docGroupNames)
                }
            }).catch(e => {})
        },
        loadDocList() {
            return new Promise((resolve, reject) => {
                let req = axios.get(`${this.$root.DOCSERVICE_BASE}/DocCenter/Setting/GetDicDocManagementList`, {
                    headers: { 'content-type': `application/x-www-form-urlencoded`, 'Authorization': sessionStorage.getItem(`doctoken`) },
                    params: { deptno: `acis2020`, permission: `0-11111111111`, vid: `xxx` }
                })
                req.then(data => {
                    resolve(_.orderBy(data.data, `PrintOrder`))
                }).catch(e => {
                    reject(e)
                })
            })
        }
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dictionary/Document/Index2.vue